var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-auto max-w-container-lg px-4 lg:px-6 xl:px-8"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }